import React, { Component } from 'react';
import Scrollspy from 'react-scrollspy';
import Scroll from './Scroll';

import avatar from '../assets/images/avatar4.jpg';
import config from '../../config';
import { withPrefix } from 'gatsby'

export class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: [
        { id: 'about', content: 'About', href: 'about' },
        { id: 'publication', content: 'Publications', href: 'publication' },
        { id: 'teaching', content: 'Teaching', href: 'teaching' },
        { id: 'cv', content: 'CV', href: 'cv' },    
      ],
      isCollapsed: true,
    };
    this.toggleNavbar = this.toggleNavbar.bind(this);
  }
  toggleNavbar() {
    this.setState({
      isCollapsed: !this.state.isCollapsed,
    });
  }

  render() {
    const { tabs, isCollapsed } = this.state;
    return (
      <nav
        className="navbar navbar-expand-lg navbar-dark bg-primary fixed-top"
        id="sideNav"
      >
        <a className="navbar-brand" href="#page-top">
          <span className="d-block d-lg-none">
            {config.firstName} {config.lastName}
          </span>
          <span className="d-none d-lg-block">
            <img
              className="img-fluid img-profile thumbnail mx-auto mb-2"
              src={avatar}
              alt="A smiling headshot of me"
            />
          </span>
        </a>
        <button
          className={`navbar-toggler navbar-toggler-right ${
            isCollapsed ? 'collapsed' : ''
            }`}
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={this.toggleNavbar}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isCollapsed ? '' : 'show'}`} id="navbarSupportedContent">
          <Scrollspy
            items={tabs.map(s => s.href)}
            currentClassName="active"
            offset={-300}
            className="navbar-nav"
          >
            {tabs.map((tab, i) => {
              const { id, href, content } = tab;
              if (id==='cv'){
              	return(
              		<li className="nav-item" key={href}>
              		<a className="nav-link" href={withPrefix('/files/FSH CV.pdf')}
              		target="_blank" rel="noopener noreferrer">{content}</a>
              		</li>
              	);
              }
              else{
              	return (
	                <li className="nav-item" key={href}>
	                  <Scroll type="id" element={href}>
	                    <a className="nav-link" href={`#${href}`}>
	                      {content}
	                    </a>
	                  </Scroll>
	                </li>
                );
              	
              }
              
            })}
          </Scrollspy>
        </div>
      </nav>
    );
  }
}

export default Sidebar;
